import React from 'react'
import classNames from 'classnames'

import Button from '../../Button/Button'
import SuggestQuery from '../RenderFields/SuggestQuery'
import RenderValueField from '../RenderFields/RenderValueFields'

const RenderQuery = (props) => {
  const {
    queryObj,
    advanceQueryArray,
    queryObjIndex,
    queryIndex,
    handleQueryRemove,
    openAutoComplete,
    activeSuggestionIndex,
    closeAutoComplete
  } = props

  const { key = [], operator = [], value = [], queryType } = props.query

  const commonPropsObj = {
    query: props.query,
    queryObj,
    queryIndex,
    queryObjIndex,
    openAutoComplete,
    activeSuggestionIndex,
    closeAutoComplete,
    fetchData: props.fetchData,
    updateAdvancedQueryArray: props.updateAdvancedQueryArray,
    queryArray: props.queryArray,
    selectedModule: props.selectedModule,
    parentQueryObject: props.parentQueryObject,
    isTaxonomyPlanEnabled: props.isTaxonomyPlanEnabled,
    cursorY: props.cursorY,
    cursorX: props.cursorX,
    isDropdownOpen: props.isDropdownOpen,
    isVisible: props.isVisible
  }

  //display value or placeholder for dropdown
  const controlledKey =
    key[0]?.label || (props.selectedModule === 'entries' ? 'Select a content type or field' : 'Select a field')
  const controlledOp = operator[0]?.label || 'Select an operator'
  //


  return (
    <div className="single-query-wrapper">
      {/* Render Key */}
      <div className="field-wrapper__key">
        {queryType !== 'localizedInLabel' && (
          <>
            <label className="fieldLabel">
              {props.selectedModule === 'entries' ? 'Content Type or Field' : 'Field'}
            </label>
            <SuggestQuery
              testId="cs-advance-search-select-field"
              type="key"
              value={controlledKey}
              placeholderClass={!key[0]?.label ? 'query-value-placeholder' : ''}
              {...commonPropsObj}
            />
          </>
        )}
      </div>
      {/* Render operator */}
      <div
        className={classNames(
          'field-wrapper__operator',
          queryType === 'localizedInLabel' && 'field-wrapper__localizedBorder'
        )}>
        <label className="fieldLabel">Operator</label>
        <SuggestQuery
          testId="cs-advance-search-select-operator"
          type="operator"
          value={controlledOp}
          placeholderClass={!operator[0]?.label ? 'query-value-placeholder' : ''}
          {...commonPropsObj}
        />
      </div>
      {/* Render Value */}
      <div className="field-wrapper__value">
        <label className="fieldLabel">Value</label>
        <div className={props?.query?.operator[0]?.value === "$exists" ? 'field-wrapper__value-disabled' : ""} style={props?.query?.operator[0]?.value === "$exists" ? { pointerEvents: "none" } : null}>
          <RenderValueField {...commonPropsObj} />
        </div>
      </div>

      {queryType !== 'localizedInLabel' && (
        <div className="field-wrapper__removeBtn">
          <Button
            testId="cs-advance-search-condition-remove"
            buttonType="tertiary"
            size="large"
            onClick={() => {
              closeAutoComplete()
              handleQueryRemove({
                queryObject: queryObj,
                currentAdvQueryArray: advanceQueryArray,
                queryObjIndex,
                queryIndex,
                currentQuery: props.query,
                action: 'removeQuery'
              })
            }}>
            Remove
          </Button>
        </div>
      )}
    </div>
  )
}

export default RenderQuery

// disable cond remove btn
// disabled={queryObj.queryArray.length === 1 && (queryObj.root || queryObj.children.length) ? true : false}
